export default class Vector2 {
    constructor(x = 0, y = 0) {
        this.$x = 0;
        this.$y = 0;
        this.$x = x;
        this.$y = y;
    }
    get x() {
        return this.$x;
    }
    get y() {
        return this.$y;
    }
    get width() {
        return this.$x;
    }
    get height() {
        return this.$y;
    }
    set x(value) {
        this.$x = value;
    }
    set y(value) {
        this.$y = value;
    }
    get length() {
        return this.magnitude;
    }
    get magnitude() {
        return Math.sqrt(this.$x * this.$x + this.$y * this.$y);
    }
    get ratio() {
        if (this.$y === 0) {
            return Infinity;
        }
        else {
            return this.$x / this.$y;
        }
    }
    diff(other) {
        return new Vector2(this.$x - other.x, this.$y - other.y);
    }
    offset(x, y) {
        return new Vector2(this.$x + x, this.$y + y);
    }
    reset() {
        this.$x = 0;
        this.$y = 0;
    }
}
//# sourceMappingURL=Vector2.js.map